import axios from "axios";
import authHeader from '../../../authheader'

const EIAPPLICATIONURL = process.env.REACT_APP_APIURL + "/api/IndividualEiApplication";

const getExperienceRecords = (applicationId) => {
    return axios.get(`${EIAPPLICATIONURL}/experiencerecords`, { headers: authHeader(), params: { applicationId} });
}
const postExperienceRecord = (data) => {
    return axios.post(`${EIAPPLICATIONURL}/experiencerecord`, data, { headers: authHeader() });
}
export default {
    getExperienceRecords,
    postExperienceRecord
}